import { computed, ElementRef, inject, input, output, signal, viewChild, } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { FormBuilder, ReactiveFormsModule } from '@angular/forms';
import { ALLOWED_FILE_TYPES, MAX_FILE_SIZE_IN_BYTES, MAX_NUMBER_OF_FILES, } from 'AgentApp/ts/constants/agent-file.constants';
import { AgentSmartCompareService } from 'AgentApp/ts/services/agent-smart-compare.service';
import { DropdownHelperService } from 'NewAngular/services/dropdown-helper.service';
import { AutoDropDirectionModule } from 'NewAngular/features/directives/auto-drop-direction/auto-drop-direction.module';
import { IconModule } from 'NewAngular/features/directives/icon/icon.module';
import { TooltipModule } from 'NewAngular/features/directives/popovers/tooltip/tooltip.module';
import { AgentSmartCompareModalComponent, } from 'AgentApp/ts/features/agent/components/agent-smart-compare-modal/agent-smart-compare-modal.component';
import { AudioTranscriptionInputComponent } from 'NewAngular/features/components/audio-transcription-input/audio-transcription-input.component';
import { isAllowedFileType } from 'AgentApp/ts/utils/agent-file';
import * as i0 from "@angular/core";
import * as i1 from "../../../../../../../../../ycharts/static/ts/features/directives/icon/icon.directive";
import * as i2 from "@angular/forms";
import * as i3 from "../../../../../../../../../ycharts/static/ts/features/directives/popovers/tooltip/tooltip.directive";
import * as i4 from "../../../../../../../../../ycharts/static/ts/features/directives/auto-drop-direction/auto-drop-direction.directive";
const _c0 = ["dropdownMenu"];
const _c1 = ["smartCompareModal"];
const _c2 = ["agentFileInput"];
const _c3 = ["audioInput"];
function AgentUserInputComponent_Conditional_0_Template(rf, ctx) { if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 4);
    i0.ɵɵelement(1, "div");
    i0.ɵɵelementStart(2, "button", 11);
    i0.ɵɵlistener("click", function AgentUserInputComponent_Conditional_0_Template_button_click_2_listener() { i0.ɵɵrestoreView(_r2); const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.openNewChat.emit()); });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(3, "svg", 12);
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(4, "span", 13);
    i0.ɵɵtext(5, "New Chat");
    i0.ɵɵelementEnd()()();
} }
function AgentUserInputComponent_Conditional_2_For_4_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 16)(1, "div", 17)(2, "div", 18)(3, "div", 19)(4, "div", 20);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(5, "svg", 21);
    i0.ɵɵelementEnd();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(6, "div", 22);
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(8, "div", 23)(9, "button", 24);
    i0.ɵɵlistener("click", function AgentUserInputComponent_Conditional_2_For_4_Template_button_click_9_listener() { const $index_r5 = i0.ɵɵrestoreView(_r4).$index; const ctx_r2 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r2.removeFile($index_r5)); });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(10, "svg", 25);
    i0.ɵɵelementEnd()()()()();
} if (rf & 2) {
    const file_r6 = ctx.$implicit;
    i0.ɵɵadvance(7);
    i0.ɵɵtextInterpolate1(" ", file_r6.name, " ");
} }
function AgentUserInputComponent_Conditional_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6)(1, "div", 14)(2, "div", 15);
    i0.ɵɵrepeaterCreate(3, AgentUserInputComponent_Conditional_2_For_4_Template, 11, 1, "div", 16, i0.ɵɵrepeaterTrackByIndex);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵrepeater(ctx_r2.uploadedFiles());
} }
function AgentUserInputComponent_Conditional_4_Template(rf, ctx) { if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ycn-audio-transcription-input", 26, 2);
    i0.ɵɵlistener("transcribedText", function AgentUserInputComponent_Conditional_4_Template_ycn_audio_transcription_input_transcribedText_0_listener($event) { i0.ɵɵrestoreView(_r7); const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.onTranscribedText($event)); })("transcriptionCancel", function AgentUserInputComponent_Conditional_4_Template_ycn_audio_transcription_input_transcriptionCancel_0_listener() { i0.ɵɵrestoreView(_r7); const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.onTranscriptionCancel()); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("placeholder", "Ask Y...")("inputText", ctx_r2.textFormControl.value ?? "")("maxCanvasWidth", ctx_r2.maxAudioCanvasWidth());
} }
function AgentUserInputComponent_Conditional_5_Template(rf, ctx) { if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 27)(1, "textarea", 28);
    i0.ɵɵlistener("keydown.enter", function AgentUserInputComponent_Conditional_5_Template_textarea_keydown_enter_1_listener($event) { i0.ɵɵrestoreView(_r8); const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.onEnter($event)); });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(2, "div", 29)(3, "div", 30)(4, "div", 31)(5, "button", 32);
    i0.ɵɵlistener("click", function AgentUserInputComponent_Conditional_5_Template_button_click_5_listener() { i0.ɵɵrestoreView(_r8); const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.toggleDropdown()); });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(6, "svg", 33);
    i0.ɵɵelementEnd();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(7, "div", 34, 3)(9, "a", 35);
    i0.ɵɵlistener("click", function AgentUserInputComponent_Conditional_5_Template_a_click_9_listener() { i0.ɵɵrestoreView(_r8); const ctx_r2 = i0.ɵɵnextContext(); const agentFileInput_r9 = i0.ɵɵreference(7); agentFileInput_r9.click(); return i0.ɵɵresetView(ctx_r2.isDropdownOpen.set(false)); });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(10, "svg", 36);
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(11, "div", 37);
    i0.ɵɵtext(12, "Attach Files");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(13, "div", 38)(14, "div", 39);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(15, "svg", 40);
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(16, "div", 37);
    i0.ɵɵtext(17, "Smart Flows");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(18, "div", 41)(19, "a", 35);
    i0.ɵɵlistener("click", function AgentUserInputComponent_Conditional_5_Template_a_click_19_listener() { i0.ɵɵrestoreView(_r8); const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.openSmartCompareModal()); });
    i0.ɵɵelementStart(20, "div", 37);
    i0.ɵɵtext(21, "Smart Compare");
    i0.ɵɵelementEnd()()()();
    i0.ɵɵelementStart(22, "a", 35);
    i0.ɵɵlistener("click", function AgentUserInputComponent_Conditional_5_Template_a_click_22_listener() { i0.ɵɵrestoreView(_r8); const ctx_r2 = i0.ɵɵnextContext(); ctx_r2.openSavedPrompts.emit(); return i0.ɵɵresetView(ctx_r2.isDropdownOpen.set(false)); });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(23, "svg", 42);
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(24, "div", 37);
    i0.ɵɵtext(25, "Saved Prompts");
    i0.ɵɵelementEnd()()()();
    i0.ɵɵelementStart(26, "button", 43);
    i0.ɵɵlistener("click", function AgentUserInputComponent_Conditional_5_Template_button_click_26_listener() { i0.ɵɵrestoreView(_r8); const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.startTranscription()); });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(27, "svg", 44);
    i0.ɵɵelementEnd();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(28, "span", 45)(29, "button", 46);
    i0.ɵɵlistener("click", function AgentUserInputComponent_Conditional_5_Template_button_click_29_listener() { i0.ɵɵrestoreView(_r8); const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.submit()); });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(30, "svg", 47);
    i0.ɵɵelementEnd()()()();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("width-full", ctx_r2.hasNewline());
    i0.ɵɵattribute("data-replicated-value", ctx_r2.textFormControl.value);
    i0.ɵɵadvance();
    i0.ɵɵproperty("formControl", ctx_r2.textFormControl);
    i0.ɵɵadvance(3);
    i0.ɵɵclassProp("show", ctx_r2.isDropdownOpen());
    i0.ɵɵproperty("ycnAutoDropDirection", true);
    i0.ɵɵadvance();
    i0.ɵɵattribute("aria-expanded", ctx_r2.isDropdownOpen());
    i0.ɵɵadvance(2);
    i0.ɵɵclassProp("show", ctx_r2.isDropdownOpen());
    i0.ɵɵadvance(19);
    i0.ɵɵproperty("tooltipTitle", "Dictation")("tooltipPlacement", "top")("tooltipIgnoreViewport", true);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("tooltipTitle", ctx_r2.submitButtonTooltip())("tooltipPlacement", "top")("tooltipIgnoreViewport", true);
    i0.ɵɵadvance();
    i0.ɵɵproperty("disabled", ctx_r2.isInputDisabled());
} }
export class AgentUserInputComponent {
    constructor() {
        this._fb = inject(FormBuilder);
        this._dropdownHelperService = inject(DropdownHelperService);
        this._smartCompare = inject(AgentSmartCompareService);
        this.maxAudioCanvasWidth = input(468, ...(ngDevMode ? [{ debugName: "maxAudioCanvasWidth" }] : []));
        this.showNewChatButton = input(false, ...(ngDevMode ? [{ debugName: "showNewChatButton" }] : []));
        this.dropdownMenu = viewChild('dropdownMenu', ...(ngDevMode ? [{ debugName: "dropdownMenu" }] : []));
        this.smartCompareModal = viewChild('smartCompareModal', ...(ngDevMode ? [{ debugName: "smartCompareModal" }] : []));
        this.fileInput = viewChild('agentFileInput', ...(ngDevMode ? [{ debugName: "fileInput" }] : []));
        this.audioInput = viewChild('audioInput', ...(ngDevMode ? [{ debugName: "audioInput" }] : []));
        this.openNewChat = output();
        this.sendMessage = output();
        this.openSavedPrompts = output();
        this.uploadedFiles = signal([], ...(ngDevMode ? [{ debugName: "uploadedFiles" }] : []));
        this.textFormControl = this._fb.control('');
        this._textValue = toSignal(this.textFormControl.valueChanges, { initialValue: '' });
        this.hasNewline = computed(() => (this._textValue() ?? '').includes('\n'), ...(ngDevMode ? [{ debugName: "hasNewline" }] : []));
        this.isDropdownOpen = signal(false, ...(ngDevMode ? [{ debugName: "isDropdownOpen" }] : []));
        this.isTranscribing = signal(false, ...(ngDevMode ? [{ debugName: "isTranscribing" }] : []));
        this.isInvalidInput = computed(() => (this._textValue() ?? '').length > AgentUserInputComponent.MAX_INPUT_LENGTH, ...(ngDevMode ? [{ debugName: "isInvalidInput" }] : []));
        this.isOverFileLimit = computed(() => this.uploadedFiles().length > MAX_NUMBER_OF_FILES, ...(ngDevMode ? [{ debugName: "isOverFileLimit" }] : []));
        this.oversizedFile = computed(() => this.uploadedFiles().find((file) => file.size > MAX_FILE_SIZE_IN_BYTES) ?? null, ...(ngDevMode ? [{ debugName: "oversizedFile" }] : []));
        this.unsupportedFile = computed(() => this.uploadedFiles().find((file) => !isAllowedFileType(file)) ?? null, ...(ngDevMode ? [{ debugName: "unsupportedFile" }] : []));
        this.submitButtonTooltip = computed(() => {
            const isOverFileLimit = this.isOverFileLimit();
            const oversizedFile = this.oversizedFile();
            const unsupportedFile = this.unsupportedFile();
            const isInvalidInput = this.isInvalidInput();
            if (isOverFileLimit) {
                return `You can only upload up to ${MAX_NUMBER_OF_FILES} files`;
            }
            if (oversizedFile) {
                return `${oversizedFile.name} exceeds the maximum file size of 32MB`;
            }
            if (unsupportedFile) {
                return `${unsupportedFile.name} is not a supported file type. Supported file types: ${ALLOWED_FILE_TYPES.join(', ')}`;
            }
            if (isInvalidInput) {
                return 'The message is too long';
            }
            return 'Send message';
        }, ...(ngDevMode ? [{ debugName: "submitButtonTooltip" }] : []));
        this.isInputDisabled = computed(() => {
            const isOverFileLimit = this.isOverFileLimit();
            const oversizedFile = this.oversizedFile();
            const unsupportedFile = this.unsupportedFile();
            const isInvalidInput = this.isInvalidInput();
            const textValue = this._textValue();
            return isOverFileLimit || !!oversizedFile || !!unsupportedFile || isInvalidInput || !textValue;
        }, ...(ngDevMode ? [{ debugName: "isInputDisabled" }] : []));
    }
    ngAfterViewInit() {
        const dropdown = this.dropdownMenu();
        if (dropdown) {
            this._dropdownHelperService.setCloseHandler(dropdown.nativeElement, () => {
                if (this.isDropdownOpen()) {
                    this.isDropdownOpen.set(false);
                }
            });
        }
    }
    toggleDropdown() {
        this.isDropdownOpen.update((x) => !x);
    }
    openSmartCompareModal() {
        this.isDropdownOpen.set(false);
        const smartCompareModal = this.smartCompareModal();
        if (smartCompareModal) {
            smartCompareModal.open();
        }
    }
    onSmartCompareSubmit(payload) {
        this._smartCompare.buildSmartComparePrompt(payload.securityIds, payload.promptText).subscribe({
            next: (messageText) => {
                this.sendMessage.emit({ text: messageText, files: [] });
            },
            error: () => {
                const smartCompareModal = this.smartCompareModal();
                if (smartCompareModal) {
                    smartCompareModal.open();
                }
            },
        });
    }
    onFileChange(event) {
        const target = event.target;
        if (target.files) {
            const newFiles = Array.from(target.files);
            this.uploadedFiles.update((existing) => {
                const combined = [...existing, ...newFiles];
                return this.getUniqueFiles(combined);
            });
        }
        this.clearFileInput();
    }
    getUniqueFiles(files) {
        return files.filter((file, index) => files.findIndex((f) => f.name === file.name &&
            f.size === file.size &&
            f.type === file.type &&
            f.lastModified === file.lastModified) === index);
    }
    removeFile(fileIndex) {
        this.uploadedFiles.update((files) => files.filter((_, i) => i !== fileIndex));
    }
    onEnter(event) {
        if (this.isInputDisabled()) {
            event.preventDefault();
            return;
        }
        if (!event.shiftKey) {
            event.preventDefault();
            this.submit();
        }
    }
    ngOnDestroy() {
        const audioInput = this.audioInput();
        if (audioInput) {
            audioInput.cancelTranscription();
        }
    }
    submit() {
        this.sendMessage.emit({ text: this.textFormControl.value, files: this.uploadedFiles() });
        this.textFormControl.setValue('');
        this.uploadedFiles.update(() => []);
    }
    clearFileInput() {
        const fileInput = this.fileInput();
        if (fileInput) {
            fileInput.nativeElement.value = '';
        }
    }
    startTranscription() {
        this.isTranscribing.set(true);
        // wait for component to render, then trigger transcription
        setTimeout(() => this.audioInput()?.startTranscription());
    }
    onTranscriptionCancel() {
        this.isTranscribing.set(false);
    }
    onTranscribedText(text) {
        this.textFormControl.setValue(text.trim());
        this.isTranscribing.set(false);
    }
}
AgentUserInputComponent.MAX_INPUT_LENGTH = 8000;
AgentUserInputComponent.ɵfac = function AgentUserInputComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || AgentUserInputComponent)(); };
AgentUserInputComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: AgentUserInputComponent, selectors: [["ycn-agent-user-input"]], viewQuery: function AgentUserInputComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuerySignal(ctx.dropdownMenu, _c0, 5);
        i0.ɵɵviewQuerySignal(ctx.smartCompareModal, _c1, 5);
        i0.ɵɵviewQuerySignal(ctx.fileInput, _c2, 5);
        i0.ɵɵviewQuerySignal(ctx.audioInput, _c3, 5);
    } if (rf & 2) {
        i0.ɵɵqueryAdvance(4);
    } }, inputs: { maxAudioCanvasWidth: [1, "maxAudioCanvasWidth"], showNewChatButton: [1, "showNewChatButton"] }, outputs: { openNewChat: "openNewChat", sendMessage: "sendMessage", openSavedPrompts: "openSavedPrompts" }, decls: 10, vars: 3, consts: [["agentFileInput", ""], ["smartCompareModal", ""], ["audioInput", ""], ["dropdownMenu", ""], [1, "d-flex", "justify-content-between", "w-full"], [1, "form-control-colors"], [1, "overflow-shadow-x"], [1, "d-flex", "justify-content-between", "align-items-center", "flex-wrap"], [1, "flex-auto", 3, "placeholder", "inputText", "maxCanvasWidth"], ["type", "file", "multiple", "", "hidden", "", 3, "change"], [3, "submitCompare"], [1, "btn", "btn-transparent-rounded", 3, "click"], ["name", "icon-add", "ycnIcon", ""], [1, "text-smallest"], [1, "overflow-shadow-inner"], [1, "d-flex", "pt-10"], [1, "plate-container"], [1, "plate", "plate-thin", "plate-noshadow", "plate-white"], [1, "plate-header", "width-full"], [1, "plate-title", "min-width-0"], [1, "plate-title-icon"], ["name", "icon-overview", "ycnIcon", ""], [1, "plate-title-name", "min-width-0", "text-ellipsis"], [1, "plate-controls"], [1, "btn", "btn-xs", "btn-circle", "btn-transparent", "btn-lightgray", "plate-control", "btn-close", 3, "click"], ["name", "icon-close", "ycnIcon", ""], [1, "flex-auto", 3, "transcribedText", "transcriptionCancel", "placeholder", "inputText", "maxCanvasWidth"], [1, "form-control-autosize", "max-rows-7", "relative", "flex-auto"], ["placeholder", "Ask Y...", "rows", "1", 1, "field-input", "border-0", "ng-pristine", "ng-untouched", "ng-valid", "ng-empty", 3, "keydown.enter", "formControl"], [1, "d-flex", "align-items-end", "ml-auto", "pt-1", "pr-2", "pb-1"], [1, "d-flex", "align-items-center", "justify-content-between", "height-40"], [1, "dropdown", "mr-1", 3, "ycnAutoDropDirection"], ["role", "button", "aria-haspopup", "true", 1, "btn", "btn-24", "btn-circle", "btn-transparent", "btn-lightgray", "dropdown-toggle", 3, "click"], ["name", "icon-add-circle", "ycnIcon", ""], [1, "dropdown-menu", "dropdown-menu-with-icons"], ["href", "javascript:void(0)", 1, "dropdown-item", 3, "click"], ["name", "icon-attach", "ycnIcon", ""], [1, "dropdown-item-text"], [1, "dropdown", "dropdown-nested"], [1, "dropdown-item", "dropdown-toggle"], ["name", "icon-sparkle", "ycnIcon", ""], [1, "dropdown-menu"], ["name", "icon-list-checked", "ycnIcon", ""], ["ycnTooltip", "", 1, "btn", "btn-24", "btn-circle", "btn-transparent", "btn-lightgray", "mr-1", 3, "click", "tooltipTitle", "tooltipPlacement", "tooltipIgnoreViewport"], ["name", "icon-microphone", "ycnIcon", ""], ["ycnTooltip", "", 1, "d-inline-block", 3, "tooltipTitle", "tooltipPlacement", "tooltipIgnoreViewport"], [1, "btn", "btn-32", "btn-circle", "btn-ai-prompt", 3, "click", "disabled"], ["name", "icon-update", "ycnIcon", ""]], template: function AgentUserInputComponent_Template(rf, ctx) { if (rf & 1) {
        const _r1 = i0.ɵɵgetCurrentView();
        i0.ɵɵconditionalCreate(0, AgentUserInputComponent_Conditional_0_Template, 6, 0, "div", 4);
        i0.ɵɵelementStart(1, "div", 5);
        i0.ɵɵconditionalCreate(2, AgentUserInputComponent_Conditional_2_Template, 5, 0, "div", 6);
        i0.ɵɵelementStart(3, "div", 7);
        i0.ɵɵconditionalCreate(4, AgentUserInputComponent_Conditional_4_Template, 2, 3, "ycn-audio-transcription-input", 8)(5, AgentUserInputComponent_Conditional_5_Template, 31, 17);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(6, "input", 9, 0);
        i0.ɵɵlistener("change", function AgentUserInputComponent_Template_input_change_6_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.onFileChange($event)); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(8, "ycn-agent-smart-compare-modal", 10, 1);
        i0.ɵɵlistener("submitCompare", function AgentUserInputComponent_Template_ycn_agent_smart_compare_modal_submitCompare_8_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.onSmartCompareSubmit($event)); });
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵconditional(ctx.showNewChatButton() ? 0 : -1);
        i0.ɵɵadvance(2);
        i0.ɵɵconditional(ctx.uploadedFiles().length > 0 ? 2 : -1);
        i0.ɵɵadvance(2);
        i0.ɵɵconditional(ctx.isTranscribing() ? 4 : 5);
    } }, dependencies: [IconModule, i1.IconDirective, ReactiveFormsModule, i2.DefaultValueAccessor, i2.NgControlStatus, i2.FormControlDirective, TooltipModule, i3.TooltipDirective, AudioTranscriptionInputComponent,
        AgentSmartCompareModalComponent,
        AutoDropDirectionModule, i4.AutoDropDirectionDirective], encapsulation: 2, changeDetection: 0 });
